import React from 'react';
import PropTypes from 'prop-types';

export type HiddenInputProps = React.ComponentPropsWithoutRef<'input'>;

export const HiddenInput: React.FC<HiddenInputProps> = ({ name = '', value = '', ...rest }) => (
    <input {...rest} name={name} value={value} type="hidden" />
);

HiddenInput.displayName = 'HiddenInput';
HiddenInput.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
};
